module.exports = __webpack_public_path__ + "static/media/deaf.4633da1f.svg";